import React, { useState } from 'react';
import { X, CheckCircle, ArrowRight, Send, Building2, Zap, Users } from 'lucide-react';
import { PRICING_SECTION } from '../constants';
import { useLanguage } from '../LanguageContext';

const ICON_MAP = { Building2: <Building2 size={22} />, Zap: <Zap size={22} />, Users: <Users size={22} /> };

function ContactModal({ onClose, modal }) {
  const [form, setForm] = useState({ nom: '', societe: '', email: '', tel: '', secteur: '', message: '' });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const bl = modal.bodyLines;
    const subject = encodeURIComponent(`${modal.subjectPrefix} — ${form.societe || form.nom}`);
    const body = encodeURIComponent(
      `${bl.nom} : ${form.nom}\n${bl.societe} : ${form.societe}\n${bl.email} : ${form.email}\n${bl.tel} : ${form.tel}\n${bl.secteur} : ${form.secteur}\n\n${bl.message} :\n${form.message}`
    );
    window.location.href = `mailto:cockpit@pitboardsuite.com?subject=${subject}&body=${body}`;
    setSent(true);
  };

  return (
    <div className="pb-modal-overlay" onClick={onClose} data-testid="pb-pricing-modal-overlay">
      <div className="pb-modal-box" onClick={e => e.stopPropagation()} data-testid="pb-pricing-modal" role="dialog" aria-modal="true" aria-label={modal.ariaLabel}>
        <div className="pb-modal-header">
          <h3 className="pb-modal-title">{modal.title}</h3>
          <button className="pb-modal-close" onClick={onClose} aria-label={modal.closeBtn} data-testid="pb-pricing-modal-close"><X size={18} /></button>
        </div>

        {sent ? (
          <div className="pb-modal-success" data-testid="pb-pricing-modal-success">
            <CheckCircle size={40} color="#0055A4" />
            <p>{modal.successMsg}</p>
            <button className="pb-btn-primary" onClick={onClose}>{modal.closeBtn}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="pb-modal-form" data-testid="pb-pricing-contact-form">
            <div className="pb-modal-row">
              <div className="pb-modal-field">
                <label>{modal.labelNom} *</label>
                <input required value={form.nom} onChange={e => set('nom', e.target.value)} placeholder={modal.phNom} data-testid="pb-modal-nom" />
              </div>
              <div className="pb-modal-field">
                <label>{modal.labelSociete}</label>
                <input value={form.societe} onChange={e => set('societe', e.target.value)} placeholder={modal.phSociete} data-testid="pb-modal-societe" />
              </div>
            </div>
            <div className="pb-modal-row">
              <div className="pb-modal-field">
                <label>{modal.labelEmail} *</label>
                <input required type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder={modal.phEmail} data-testid="pb-modal-email" />
              </div>
              <div className="pb-modal-field">
                <label>{modal.labelTel}</label>
                <input type="tel" value={form.tel} onChange={e => set('tel', e.target.value)} placeholder={modal.phTel} data-testid="pb-modal-tel" />
              </div>
            </div>
            <div className="pb-modal-field">
              <label>{modal.labelSecteur}</label>
              <select value={form.secteur} onChange={e => set('secteur', e.target.value)} data-testid="pb-modal-secteur">
                <option value="">{modal.sectorPh}</option>
                {modal.sectors.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div className="pb-modal-field">
              <label>{modal.labelMessage}</label>
              <textarea rows={3} value={form.message} onChange={e => set('message', e.target.value)} placeholder={modal.phMessage} data-testid="pb-modal-message" />
            </div>
            <button type="submit" className="pb-btn-primary" style={{ width: '100%', justifyContent: 'center' }} data-testid="pb-modal-submit">
              {modal.submit}
              <Send size={15} />
            </button>
            <p className="pb-modal-legal">{modal.legal}</p>
          </form>
        )}
      </div>
    </div>
  );
}

export default function Pricing() {
  const { lang }   = useLanguage();
  const section    = PRICING_SECTION[lang];
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="pb-section pb-section-pad pb-pricing-section" id="tarifs" data-testid="pb-pricing">
        <div className="pb-container">
          <div className="pb-pricing-inner">
            <div className="pb-pricing-left">
              <div className="pb-label pb-label-light">{section.label}</div>
              <h2 className="pb-pricing-title" style={{ color: '#ffffff' }}>
                {section.title.split('\n').map((line, i) => (
                  <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
                ))}
              </h2>
              <p className="pb-pricing-desc" style={{ color: 'rgba(255,255,255,0.7)' }}>{section.desc}</p>
              <button className="pb-btn-pricing" style={{ color: '#0A192F' }} onClick={() => setOpen(true)} data-testid="pb-pricing-cta">
                {section.cta}
                <ArrowRight size={16} />
              </button>
            </div>

            <div className="pb-pricing-cards">
              {section.avantages.map((a, i) => (
                <div key={i} className="pb-pricing-card" data-testid={`pb-pricing-avantage-${i}`}>
                  <div className="pb-pricing-card-icon">{ICON_MAP[a.iconKey]}</div>
                  <div>
                    <div className="pb-pricing-card-title">{a.title}</div>
                    <div className="pb-pricing-card-desc">{a.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {open && <ContactModal onClose={() => setOpen(false)} modal={section.modal} />}
    </>
  );
}
